<template>
    <div class="pt-2">
        <div class="px-4">
            <v-tabs v-model="activeTab" style="border-radius: 12px">
                <v-tab value="Data">Dossiers</v-tab>
                <v-tab
                    value="Monitoring"
                    v-if="isAllowedToStatusOfFiles"
                    data-cy="AccountingClients-etatAvancementDossiers"
                    >Etat d'avancement des dossiers</v-tab
                >
            </v-tabs>
        </div>
        <v-tabs-window v-model="activeTab">
            <v-window-item value="Data">
                <v-row no-gutters cols="12" class="my-2 justify-center">
                    <!-- <v-col cols="2" class="px-2">
                        <v-select
                            v-model="selectedAccontingType"
                            :items="accountingTypes"
                            label="Comptabilité"
                            outlined
                            hide-details
                            dense
                            elevation="0"
                        ></v-select>
                    </v-col>
                    <v-col cols="2" class="px-2">
                        <v-select
                            v-model="selectedLegalForm"
                            :items="LegalForm"
                            label="Type de société"
                            outlined
                            hide-details
                            dense
                            elevation="0"
                        ></v-select>
                    </v-col> -->
                    <v-col cols="4" class="pl-4">
                        <v-text-field
                            v-model="search"
                            label="Recherche"
                            outlined
                            hide-details
                            data-cy="AccountingClients-search"
                            density="compact"
                            clearable
                            append-inner-icon="$search"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col class="px-4">
                        <oss-data-table
                            :headers="headers"
                            :items="filteredCompanies"
                            class="table"
                            :striped="true"
                            :dense="true"
                            fixed-header
                            :virtualScroll="true"
                            height="calc(100vh - 176px)"
                        >
                            <template v-slot:item="props">
                                <tr @click.stop="openClient(props.item)" style="cursor: pointer">
                                    <td>
                                        {{ props.item.legalForm || "" }}
                                    </td>
                                    <td>
                                        {{ props.item.name }}
                                    </td>
                                    <td>
                                        {{ props.item.siret ? props.item.siret.split("_")[0] : "" }}
                                    </td>
                                    <td>
                                        <v-tooltip
                                            v-if="props.item && props.item.activity"
                                            location="bottom"
                                        >
                                            <template v-slot:activator="{ props }">
                                                <span v-bind="props">{{
                                                    props.item?.activity || ""
                                                }}</span>
                                            </template>
                                            <span>{{ props.item.activityDescription }}</span>
                                        </v-tooltip>
                                    </td>
                                    <td>
                                        {{
                                            props.item.incomeCategory
                                                ? $t("settings." + props.item.incomeCategory)
                                                : ""
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            props.item.taxRegime
                                                ? $t("settings." + props.item.taxRegime)
                                                : ""
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            props.item.taxSystemType
                                                ? $t("settings." + props.item.taxSystemType)
                                                : ""
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            props.item.vatSystem
                                                ? $t("settings." + props.item.vatSystem)
                                                : ""
                                        }}
                                    </td>
                                </tr>
                            </template>
                        </oss-data-table>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item value="Monitoring">
                <AccountingClientMonitoring :mode="mode"> </AccountingClientMonitoring>
            </v-window-item>
        </v-tabs-window>
    </div>
</template>

<script lang="ts">
import { User } from "../../store/store";

import { Offer_type } from "@/types/offer.types";

import AccountingClientMonitoring from "./AccountingClientMonitoring.vue";

import ossDataTable from "../ossComponents/ossDataTable2.vue";
import { setCurrentCompany } from "../../services/userServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { OfferAccessRight } from "@/services/accessRightServices";

class Company {
    activities: any;
    constructor() {}

    get activity() {
        if (this.activities?.length) {
            return this.activities[0].name;
        }
        return "";
    }

    get activityDescription() {
        if (this.activities?.length) {
            return this.activities[0].description;
        }
        return "";
    }
}

@Component({
    components: {
        AccountingClientMonitoring,
        ossDataTable,
    },
})
export class AccountingClients extends Vue {
    @Prop({ default: "internalManagement" }) mode: string;

    activeTab = "Data";

    search: string = "";

    get offerType() {
        return this.$store.state.offerType;
    }

    get isUserHasAccess() {
        return this.$store.getters.isUserHasAccess();
    }

    get isAllowedToStatusOfFiles() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_BASIC:
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.TRAINING:
        // if (this.isUserHasAccess) {
        // return true;
        // }
        // return false;
        // default:
        // return false;
        // }
        return OfferAccessRight.checkOfferAccessRight("isAllowedToStatusOfFiles", true);
    }

    get headers() {
        return [
            {
                text: "Forme",
                value: "legalForm",
                sortable: true,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (item) => {
                            if (item) return item;
                            return "Sans forme jurifique";
                        },
                    },
                },
            },
            { text: "Dossier", value: "name", sortable: true, filterable: { type: "includes" } },
            { text: "Siret", value: "siret", sortable: true, filterable: { type: "includes" } },
            {
                text: "Code NAF",
                value: "activity",
                sortable: true,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (item) => {
                            if (item) return item;
                            return "Sans code NAF";
                        },
                    },
                },
            },
            {
                text: "Catégorie de revenu",
                value: "incomeCategory",
                sortable: true,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (item) => {
                            if (item) return this.$t("settings." + item);
                            return "Sans catégorie de revenu";
                        },
                    },
                },
            },
            {
                text: "Régime fiscal",
                value: "taxRegime",
                sortable: true,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (item) => {
                            if (item) return this.$t("settings." + item);
                            return "Sans régime fiscal";
                        },
                    },
                },
            },

            {
                text: "Imposition",
                value: "taxSystemType",
                sortable: true,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (item) => {
                            if (item) return this.$t("settings." + item);
                            return "Sans imposition";
                        },
                    },
                },
            },
            {
                text: "Régime TVA",
                value: "vatSystem",
                sortable: true,
                filterable: {
                    type: "equals",
                    options: {
                        toText: (item) => {
                            if (item) return this.$t("settings." + item);
                            return "Sans régime de TVA";
                        },
                    },
                },
            },
        ];
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get allAvailableCompanies() {
        const companies = [];
        if (this.currentUser?.allAvailableCompanies?.length) {
            for (const company of this.currentUser.allAvailableCompanies) {
                companies.push(Object.assign(new Company(), company, {}));
            }
        }
        return companies;
    }

    get filteredCompanies() {
        // debugger
        let array: any = [];

        if (this.allAvailableCompanies?.length) {
            let clients = this.allAvailableCompanies.sort((a: any, b: any) =>
                a.name.localeCompare(b.name),
            );
            if (this.search) {
                const lSearch = this.search.toLowerCase();
                for (const client of clients) {
                    if (client.name && client.name.toLowerCase().indexOf(lSearch) !== -1) {
                        array.push(client);
                    } else if (client.siret && client.siret.indexOf(lSearch) !== -1) {
                        array.push(client);
                    }
                }
                clients = array;
                array = [];
            }
            // if (this.selectedLegalForm) {
            //     for (let i = 0; i<clients.length; i++) {
            //         if(clients[i].legalForm) {
            //             if(clients[i].legalForm===this.selectedLegalForm) {
            //                 array.push(clients[i])
            //             }
            //         }
            //     }
            //     clients = array
            // }
            // array = []
            // if (this.selectedAccontingType) {
            //     for (let i = 0; i<clients.length; i++) {
            //         if(clients[i].profile) {
            //             if(clients[i].profile.accountingType) {
            //                 if(clients[i].profile.accountingType === this.selectedAccontingType) {
            //                     array.push(clients[i])
            //                 }
            //             }
            //         }
            //     }
            //     clients = array
            // }
            return clients.sort((a: any, b: any) => a.name.localeCompare(b.name));
        }
        return array;
    }

    async openClient(selectedCompany) {
        await setCurrentCompany(this.$apollo, this.$store, selectedCompany, undefined, true);
        // this.$router.push({
        //     name: "documents",
        //     params: {
        //         resetFilter: "true"
        //     }
        // })
        this.$router.push({ name: "companyStatusBoard" });
    }
}

export default toNative(AccountingClients);
</script>
